import type { PrimaryAtmosphere } from '@wineryxplorer/shared';

interface PrimaryAtmosphereDisplayProps {
  value?: PrimaryAtmosphere;
  className?: string;
}

const PRIMARY_ATMOSPHERE_LABELS = {
  casual: 'Casual',
  upscale: 'Upscale',
  rustic: 'Rustic',
  modern: 'Modern',
} as const;

const PRIMARY_ATMOSPHERE_DESCRIPTIONS = {
  casual: 'Relaxed, informal setting',
  upscale: 'Sophisticated, refined atmosphere',
  rustic: 'Country, farmhouse, traditional feel',
  modern: 'Contemporary, sleek design',
} as const;

export const PrimaryAtmosphereDisplay = ({ value, className = '' }: PrimaryAtmosphereDisplayProps) => {
  if (!value) {
    return null;
  }

  const label = PRIMARY_ATMOSPHERE_LABELS[value];
  const description = PRIMARY_ATMOSPHERE_DESCRIPTIONS[value];

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <span
        className="text-gray-900 font-medium text-sm sm:text-base"
        title={description}
        aria-label={`Atmosphere: ${label} - ${description}`}
      >
        {label}
      </span>
    </div>
  );
};